/* eslint-disable jsx-a11y/label-has-associated-control */

import PropTypes from 'prop-types';

import {
  TextAreaContainer, StyledTextArea, Label, Counter
} from './useStyles';

export const TextArea = ({
  placeholder, text, onChangeHandler, className, maxLength
}) => (
  <TextAreaContainer className={className}>
    <StyledTextArea
      required
      maxLength={maxLength}
      value={text}
      onChange={onChangeHandler}
    />
    <Label className="label">{placeholder}</Label>
    <Counter className="counter">
      {text.length}
      {' '}
      /
      {' '}
      {maxLength}
    </Counter>
  </TextAreaContainer>
);

TextArea.propTypes = {
  placeholder: PropTypes.string,
  text: PropTypes.string,
  onChangeHandler: PropTypes.func,
  maxLength: PropTypes.number
};

TextArea.defaultProps = {
  placeholder: '',
  text: '',
  onChangeHandler: () => {},
  maxLength: 140
};
